import type { GhostLabeller } from "@helm/chart";
import { ghostLabel, protectGhostLabel, type LinePnlBasis } from "@helm/ui";

/**
 * The trade-line drag ghost's label (SPEC §9.3 "a ghost line shows the new price and the tick
 * distance from market"), plus the P&L if it filled there in the user's unit — the same
 * `linePnlAt` that labels the resting line, so the two never disagree. A drag off a position
 * line previews the TP / SL it creates: price, distance from the average (ticks, points) and the
 * P&L there for the whole position (`protectGhostLabel`; off the tag's TP / SL chip, that order,
 * refused on the wrong side). Runs in the render worker (and the
 * compat renderer): the line carries its P&L basis, the engine only passes it back.
 */
export const tradeGhostLabel: GhostLabeller = (line, toTicks, priceText, lastTicks, chip) =>
  line.kind === "position"
    ? protectGhostLabel(
        {
          side: line.side,
          priceTicks: line.priceTicks,
          protect: line.protect ?? null,
          pnlBasis: line.pnlBasis as LinePnlBasis | null,
        },
        toTicks,
        priceText,
        chip,
      )
    : ghostLabel(
        { kind: line.kind, label: line.label, pnlBasis: line.pnlBasis as LinePnlBasis | null },
        toTicks,
        priceText,
        lastTicks,
      );
